import React from "react";

 function Error(){
    return(
        <div className="error">
            <h1>Puslapis šiuo metu yra kuriamas, užeikite vėliau.</h1>
        </div>
    )
}
export default Error;